<template>
  <ActBox
    :postActivityCountries="postActivityCountries"
    :postActivityInfo="postActivityInfo"
    :postActivityInprocess="postActivityInprocess"
    :postActivityJoin="postActivityJoin"
    :postActivityMine="postActivityMine"
    :postActivityMyjoins="postActivityMyjoins"
    :postActivityWinlists="postActivityWinlists"
    :postActivityRank="postActivityRank" />
</template>
<script>
import {
  postActivityCountries,
  postActivityInfo,
  postActivityInprocess,
  postActivityJoin,
  postActivityMine,
  postActivityMyjoins,
  postActivityRank,
  postActivityWinlists
} from '@/api/user'
import ActBox from '@/components/ActBox.vue'

export default {
  name: 'UserActivity',
  components: {
    ActBox
  },
  data() {
    return {
      postActivityCountries,
      postActivityInfo,
      postActivityInprocess,
      postActivityJoin,
      postActivityMine,
      postActivityMyjoins,
      postActivityRank,
      postActivityWinlists
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/user/activity.vue